<h1 mat-dialog-title>
    <span translate>admin.parametres.authentification.saml.clefPrivee</span>
    <span [mat-dialog-close]="null"><i class="zmdi zmdi-close"></i></span>
</h1>
<form #form="ngForm">
    <div mat-dialog-content>
        <fieldset class="mt-2 limited-height">
            <div class="row">
                <custom-input
                        ngDefaultControl
                        id="libelle"
                        name="libelle"
                        customType="textarea"
                        [(ngModel)]="data.clefPrivee"
                        lCol="2" rCol="10"
                        libelle="admin.parametres.authentification.saml.clefPrivee"
                        [maxlength]="5000"
                        [postTooltip]="'admin.parametres.authentification.saml.format' | translate"
                ></custom-input>
            </div>
        </fieldset>

    </div>
    <div mat-dialog-actions align="end">
        <button mat-stroked-button color="warn" [mat-dialog-close]="null">
            <span *ngIf="!isSaving" translate>global.actions.annuler</span>
            <mat-spinner class="m-5" diameter="28" *ngIf="isSaving"></mat-spinner>
        </button>
        <button mat-flat-button color="primary" type="submit" (click)="onSave()" [disabled]="form.invalid">
            <span *ngIf="!isSaving" translate>global.actions.valider</span>
            <mat-spinner class="m-5" diameter="28" *ngIf="isSaving"></mat-spinner>
        </button>
    </div>
</form>